import '@babel/polyfill'
// import 'mutationobserver-shim'
// CSS for bootstrap
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import Vue from 'vue'
// import './plugins/bootstrap-vue'
import store from './store/index'
import BootstrapVue from 'bootstrap-vue'
import { MdButton, MdProgress, MdIcon, MdCard, MdField, MdMenu} from 'vue-material/dist/components'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import vueCustomElement from 'vue-custom-element'

import App from './App.vue'

Vue.use(MdButton)
Vue.use(MdProgress)
Vue.use(MdIcon)
Vue.use(MdCard)
Vue.use(MdField)
Vue.use(MdMenu)


Vue.use(vueCustomElement)

Vue.use(BootstrapVue)

Vue.config.productionTip = false

import { Navbar } from 'bootstrap-vue/es/components'
Vue.use(Navbar)

const app = new Vue({
  store,
  render: h => h(App)
});

/* Mount */

(() => {
  const script_element = document.querySelector('script[airsset]');

  // Get HTML head element
  let head = document.getElementsByTagName('HEAD')[0];
 
  // Create new link Element
  let link = document.createElement('link');

  // set the attributes for link element
  link.rel = 'stylesheet';

  link.type = 'text/css';

  let path = script_element.src.substring(0, script_element.src.lastIndexOf('/'));
  
  link.href = path + '/app.css';

    
  // Append link element to HTML head
  head.appendChild(link);

  if (!script_element) {
    console.error('Cannot find Airsset widget script.');
    return;
  }

  // Find the API key
  let key = null;
  const query_string = new URLSearchParams(window.location.search.substring(1));

  if (script_element.dataset.key !== undefined) {
    key = script_element.dataset.key;
  } else if (query_string.has('key')) {
    key = query_string.get('key');
  }

  if (!key) {
    console.error('No Airsset widget key provided.');
    return;
  }

  Vue.prototype.$airsset_key = key;

  // Set up the container
  const container = document.createElement('div');
  script_element.after(container);

  app.$mount(container);
})();







